import _ from "lodash";
import LayoutUtils from "./LayoutUtils";

class ElementGroup {
  constructor() {
    this.id = null;
    this.elements = [];
    this.bounds = null;

    this.height = 0;
    this.width = 0;
  }

  addElement(element) {
    this.elements.push(element);
  }

  prepare() {
    this.bounds = LayoutUtils.getBoundingRect(_.map(this.elements, "rect"));

    this._toLocal();
  }

  _toLocal() {
    _.each(
      this.elements,
      _.bind(function (elementData, idx) {
        elementData.localRect = this._getLocalRect(elementData);
      }, this)
    );
  }

  _getLocalRect(elementData) {
    let localRect = _.clone(elementData.rect);

    localRect.x = elementData.rect.x - this.bounds.x;
    localRect.y = elementData.rect.y - this.bounds.y;
    localRect.x2 = elementData.rect.w + localRect.x;
    localRect.y2 = elementData.rect.h + localRect.y;

    return localRect;
  }
}

export default ElementGroup;
